import React from 'react';
;

var PrimaryButton = function PrimaryButton(_ref) {
  var primaryBtnClassName = _ref.primaryBtnClassName,
      primaryBtnIcon = _ref.primaryBtnIcon,
      primaryBtnIconClassName = _ref.primaryBtnIconClassName,
      onClick = _ref.onClick,
      btnType = _ref.btnType,
      btnTextOverride = _ref.btnTextOverride;
  return React.createElement("button", Object.assign({
    className: primaryBtnClassName || ''
  }, onClick && {
    onClick: onClick
  }, {
    type: btnType
  }), btnTextOverride || 'Continue', primaryBtnIcon && React.createElement("span", {
    className: primaryBtnIconClassName || ''
  }, primaryBtnIcon));
};

export default PrimaryButton;